import React from 'react';
import { RouteObject } from 'react-router-dom';

import { Layout } from '#component/layout';
import { SDKLayout } from '#component/sdk-layout';
import { ErrorBoundaryRouter } from '#component/error-boundary/router';

import { Route404 } from './404';

export const COMMON: Array<RouteObject> = [
    {
        element      : <Layout />,
        ErrorBoundary: ErrorBoundaryRouter,
        children     : [{
            path    : '/',
            children: [{
                path    : 'campaigns',
                children: [{
                    path: 'news',
                    lazy: () => import('./news')
                }, {
                    path: 'list/:campaignStatus?',
                    lazy: () => import('./campaigns/list-my-campaigns')
                }, {
                    path: 'create/:type',
                    lazy: () => import('./campaigns/create')
                }, {
                    path: 'edit/:id',
                    lazy: () => import('./campaigns/edit')
                }, {
                    path: 'statistics/:campaignStatus?',
                    lazy: () => import('./statistics')
                }, {
                    path: 'statistics/details/:id',
                    lazy: () => import('./statistics/details')
                }, {
                    path: 'finances',
                    lazy: () => import('./finances')
                }, {
                    path: 'finances/refill',
                    lazy: () => import('./finances/pages/refill')
                }, {
                    path: 'finances/refill/status/:transaction?',
                    lazy: () => import('./finances/pages/payment-status')
                }, {
                    path: 'help/:type?/:id?',
                    lazy: () => import('./help')
                }, {
                    path: 'promotions/:type?/:promotionsStatus?',
                    lazy: () => import('./promotions')
                }]
            },
            {
                path    : 'support',
                children: [{
                    path: 'dialogs',
                    lazy: () => import('./dialogs')
                },
                {
                    path: 'dialogs/:id',
                    lazy: () => import('./dialog')
                }]
            }]
        }, {
            path: '/external-traffic/',
            lazy: () => import('./external-traffic')
        }, {
            path: '/link-generator',
            lazy: () => import('./link-generator')
        }, {
            path   : '*',
            element: <Route404 />
        }]
    },
    {
        element      : <SDKLayout />,
        ErrorBoundary: ErrorBoundaryRouter,
        children     : [{
            path    : '/sdk',
            children: [{
                path: 'start-auto-campaign',
                lazy: () => import('./sdk/start-auto-campaign')
            }]
        }]
    }
];
